"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Progress = void 0;

var _react = _interopRequireDefault(require("react"));

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

(0, _loadStyles.default)(".c7f79960e{position:relative;background-color:var(--color-flomni-blue-70);overflow:hidden;height:.25rem}.c3ce721ae{background-color:var(--color-flomni-gray-40);width:auto;-webkit-animation:c9649f447 2.1s cubic-bezier(.65,.815,.735,.395) infinite;animation:c9649f447 2.1s cubic-bezier(.65,.815,.735,.395) infinite;position:absolute;left:0;bottom:0;top:0;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear;-webkit-transform-origin:left;transform-origin:left}.cf1754c25{background-color:var(--color-flomni-gray-40);width:auto;-webkit-animation:c39e1640b 2.1s cubic-bezier(.165,.84,.44,1) infinite;animation:c39e1640b 2.1s cubic-bezier(.165,.84,.44,1) infinite;-webkit-animation-delay:1.15s;animation-delay:1.15s;position:absolute;left:0;bottom:0;top:0;transition:-webkit-transform .2s linear;transition:transform .2s linear;transition:transform .2s linear,-webkit-transform .2s linear;-webkit-transform-origin:left;transform-origin:left}@-webkit-keyframes c9649f447{0%{left:-35%;right:100%}60%{left:100%;right:-90%}100%{left:100%;right:-90%}}@keyframes c9649f447{0%{left:-35%;right:100%}60%{left:100%;right:-90%}100%{left:100%;right:-90%}}@-webkit-keyframes c39e1640b{0%{left:-200%;right:100%}60%{left:107%;right:-8%}100%{left:107%;right:-8%}}@keyframes c39e1640b{0%{left:-200%;right:100%}60%{left:107%;right:-8%}100%{left:107%;right:-8%}}");
var styles = {
  root: 'c7f79960e',
  bar: 'c3ce721ae',
  fclprogressbar: 'c9649f447',
  rail: 'cf1754c25',
  fclprogressrail: 'c39e1640b'
};

var Progress = function Progress(props) {
  var classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.bar
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.rail
  }));
};

exports.Progress = Progress;
Progress.propTypes = {
  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
Progress.defaultProps = {
  classes: {}
};